import { render, staticRenderFns } from "./SaltoSetting.vue?vue&type=template&id=6512172a&scoped=true"
import script from "./SaltoSetting.vue?vue&type=script&lang=js"
export * from "./SaltoSetting.vue?vue&type=script&lang=js"
import style0 from "./SaltoSetting.vue?vue&type=style&index=0&id=6512172a&prod&lang=css"
import style1 from "./SaltoSetting.vue?vue&type=style&index=1&id=6512172a&prod&scoped=true&lang=css"
import style2 from "./SaltoSetting.vue?vue&type=style&index=2&id=6512172a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6512172a",
  null
  
)

export default component.exports